import script from "./DateRangePicker.vue?vue&type=script&setup=true&lang=js"
export * from "./DateRangePicker.vue?vue&type=script&setup=true&lang=js"

import "./DateRangePicker.vue?vue&type=style&index=0&id=1b7e5756&lang=css"

const __exports__ = script;

export default __exports__